// LogoutScreen.jsx
//Implementado después de comunicado de usar unibi.unisupergt.com/#/logout como primer paso para limpiar cookies. No se usa fuera de eso
import { useEffect } from "react";
import { useAuth0 } from "@auth0/auth0-react";

function deleteCookie(name) {
  // Intenta varias combinaciones para el dominio actual
  const host = window.location.hostname;
  const bases = [host];

  // También intenta con el dominio “.raíz” (p.ej. .unisupergt.com)
  const parts = host.split(".");
  if (parts.length > 2) bases.push("." + parts.slice(-2).join("."));
  else bases.push("." + host);

  const opts = (domain) => `;expires=Thu, 01 Jan 1970 00:00:00 GMT;path=/;domain=${domain}`;

  // Sin domain y con domain
  document.cookie = `${name}=;expires=Thu, 01 Jan 1970 00:00:00 GMT;path=/`;
  bases.forEach((d) => (document.cookie = `${name}=${opts(d)}`));
}

export default function LogoutScreen() {
  const { logout, isAuthenticated } = useAuth0();

  useEffect(() => {
    // Limpieza opcional del lado del cliente (ajusta a tus llaves reales)
    try {
      // Si usas cacheLocation: 'localstorage' en Auth0, sus claves típicas empiezan con '@@auth0spajs@@'
      Object.keys(localStorage)
        .filter((k) => k.startsWith("@@auth0spajs@@") || k.startsWith("auth0.") || k.startsWith("unibi:"))
        .forEach((k) => localStorage.removeItem(k));

      sessionStorage.clear();

      // Si tu app crea cookies propias, nómbralas aquí:
      ["unibi_session", "unibi_prefs"].forEach(deleteCookie);
    } catch (e) {
      // no-op
    }

    // Importante: el returnTo debe estar en Allowed Logout URLs
    const returnTo = `${window.location.origin}/`;

    if (isAuthenticated) {
      // v2 del SDK: usar logoutParams
      logout({ logoutParams: { returnTo } });
    } else {
      // Si ya no está autenticado, redirige manualmente
      window.location.replace(returnTo);
    }
  }, [logout, isAuthenticated]);

  return (
    <div style={{ padding: 24 }}>
      <h1>Cerrando sesión…</h1>
      <p>Si no ocurre nada, <a href="/">haz clic aquí</a>.</p>
    </div>
  );
}
